import { Subject } from 'rxjs';
export const error$ = new Subject();
